// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zUpl","label":"styles_label__1K4UU"};